<template>
  <div>
    <div class="role"></div>
    <div class="role1">
      <el-form ref="elForm" inline>
        <el-form-item>
          <el-input v-model="query.role_name" placeholder="请输入角色名称或手机号" clearable
            @keyup.enter.native="handleCurrentChange(1)">
          </el-input>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'role1/query')">
          <el-button type="primary" @click="handleCurrentChange(1)" icon="el-icon-search"> 查询 </el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'role1/increase')">
          <el-button type="success" @click="xinzeng" icon="el-icon-circle-plus"> 新增 </el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'role1/delete')">
          <el-button :disabled="!multipleSelection.length" type="danger" @click="handleDelete1" icon="el-icon-milk-tea">
            删除 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="role2" v-loading='loading'>
      <el-table stripe border ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 50%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" align='center' width="55">
        </el-table-column>
        <el-table-column label="角色名称" align='center' show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.role_name }}</template>
        </el-table-column>
        <el-table-column prop="role_remark" align='center' label="说明" show-overflow-tooltip>
        </el-table-column>

        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <el-button v-if="JudgeButton(role_permission,'role1/edit')" size="mini" type="primary"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button v-if="JudgeButton(role_permission,'role1/delete')" size="mini" type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="role3">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 30, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="count">
      </el-pagination>
    </div>



    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="30%" v-el-drag-dialog :before-close="close" destroy-on-close>
      <el-form ref="added" :model="form" :rules="rules1" size="medium" label-width="160px" style="padding-right: 40px;">
        <el-col :span="24">
          <el-form-item label="角色名称：" prop="name">
            <el-input :maxlength='15' show-word-limit v-model="form.name" placeholder="请输入角色名称：" clearable>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="角色说明：">
            <el-input :maxlength='100' type='textarea' :rows='5' show-word-limit v-model="form.name1"
              placeholder="请输入角色说明">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="权限配置：">
            <el-tree ref="tree" :data="routesData" show-checkbox :props="{
				children: 'children',
				label: 'title'
			  }" :default-checked-keys='checked' :check-strictly='false' node-key="path" class="permission-tree" />
          </el-form-item>
        </el-col>
      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="handelConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import elDragDialog from "@/utils/el-dragDialog";
  import {
    deepClone1,
    asyncRouterMap1,
    constantRouterMap1
  } from './role';
  import path from 'path'
  import userInfoAPI from '@/api/api'
  export default {
    name: 'roleManage',
    props: {},
    data() {
      return {
        count: 0,
        tableData: [],
        multipleSelection: [],
        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
          name1: '',
          id: '',
        },
        rules1: {
          name: [{
              required: true,
              message: '请输入角色名称',
              trigger: 'blur'
            },
            {
              min: 3,
              max: 18,
              message: '长度在 3 到 18 个字符',
              trigger: 'blur'
            }
          ],
        },
        routes: [],
        checked: [],
        userInfo: '',
        routesData: [],
        editDatas: [],
        loading: true,
        query: {
          role_name: '',
          page_limit: 10,
          page: 1,
        }
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    directives: {
      elDragDialog,
    },
    created() {
      if (this.$store.state.cache.cacheRoleQuery) this.query = this.$store.state.cache.cacheRoleQuery
      this.init();
    },
    mounted() {
      this.getRoutes()
    },
    beforeDestroy() {
      this.$store.commit('CACHE_ROLE', this.query)
    },
    methods: {
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      init() {
        this.loading = true
        userInfoAPI.adminRole1(this.query).then(({
          data
        }) => {
          if (data.code == 0) {
            this.count = data.data.page.count * 1;
            this.tableData = data.data.list;
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            })
          }
          this.loading = false
        })
      },
      xinzeng() {
        this.title = '';
        this.form.name = '';
        this.form.name1 = '';
        this.form.id = '';
        this.checked = [];
        this.dialogFormVisible = true;
        this.routesData = JSON.parse(JSON.stringify(this.routes))
        this.title = '新增'
      },
      handleSelectionChange(val) { //框框事件
        this.multipleSelection = val;
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.init();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.init();
      },

      handleEdit(index, row) { //编辑
        if (this.userInfo.role_id == 1) { // 管理员才能查看所有权限
          this.routesData = JSON.parse(JSON.stringify(this.routes))
        } else {
          let routesData = JSON.parse(JSON.stringify(this.routes))
          routesData = routesData.filter(i => row.role_permission.find(j => j.path == i.path))
          routesData.forEach(i => {
            if (i.children && i.children.length) {
              i.children = i.children.filter(c => row.role_permission.find(k => k.path == c.path))
              i.children.forEach(item => {
                item.children = item.children.filter(c => row.role_permission.find(k => k.path == c.path))
              })
            }
          })
          this.routesData = [].concat(routesData)
        }
        if (row.role_name == 'admin' && this.userInfo.role_id != 1) {
          this.$message({
            showClose: true,
            message: '禁止编辑超级管理员账户,如需修改请联系管理员',
            type: 'error'
          })
          return
        } else {
          this.title = '编辑用户：' + row.role_name;
          this.form.name = row.role_name;
          this.form.name1 = row.role_remark;
          this.form.id = row.role_id;
          let checked = [];
          console.log(row.role_permission)
          row.role_permission.forEach(i => {
            if(this.editDatas.find(e=>e.path == i.path)){
              checked.push(i.path)
            }
            // if (i.path == '/recycle' || i.path == '/service' || i.path == '/guide' || i.path == '/message' || i.path == '/company' || i.path == '/operate') {
            //   // 顶级节点不加入选中列表，否则默认将选中全部
            // } else {
            //   checked.push(i.path)
            // }
          })
          this.checked = checked;
          this.dialogFormVisible = true;
        }
      },
      handleDelete(index, row) { //删除
        this.$confirm('此操作将永久删除该角色, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.adminRole4(row.role_id).then(({
            data
          }) => {
            if (data.code == 0) {
              this.init();
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
              });
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error'
              });
            }
          })
        })
      },
      handleDelete1() {
        this.$confirm('此操作将永久删除该角色, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.adminRole4(this.multipleSelection.map(i => {
            return i.role_id
          }).join(',')).then(({
            data
          }) => {
            if (data.code == 0) {
              this.init();
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
              });
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error'
              });
            }
          })
        })
      },
      close() { //弹窗关闭
        this.title = '';
        this.form.name = '';
        this.form.name1 = '';
        this.form.id = '';
        this.checked = [];
        this.$refs.tree.setCheckedKeys([]);
        this.dialogFormVisible = false;
        this.$refs['added'].resetFields(); //强制清理表格内容 
      },
      handelConfirm() { //弹窗确认功能按钮
        this.$refs['added'].validate(valid => {
          if (valid) {
            let role_permission = [];
            this.checked = this.$refs.tree.getCheckedKeys() || [];
            let half = this.$refs.tree.getHalfCheckedKeys() || [] // 半选的也要算入选择
            half = half.map(h => {
              return {
                path: h
              }
            })
            if (this.checked && this.checked.length > 0) {
              this.checked.forEach(i => {
                role_permission.push({
                  path: i
                })
              })
            }
            role_permission = role_permission.concat(half)
            // console.log(role_permission)
            // return
            if (this.title == '新增') {
              userInfoAPI.adminRole3({
                role_name: this.form.name,
                role_remark: this.form.name1,
                role_permission
              }).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.init();
                  this.close();
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  });
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  });
                }
              })
            } else {
              userInfoAPI.adminRole2({
                role_name: this.form.name,
                role_remark: this.form.name1,
                role_permission
              }, this.form.id).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.init();
                  this.close();
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  });
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  });
                }
              })
            }
          }
        })
      },
      generateRoutes(routes, basePath = '/') {
        const res = []
        for (let route of routes) {
          // skip some route
          if (route.hidden) {
            continue
          }
          const onlyOneShowingChild = this.onlyOneShowingChild(route.children, route)

          if (route.children && onlyOneShowingChild && !route.alwaysShow) {
            route = onlyOneShowingChild
          }
          var data = {
            path: route.path,
            name: path.resolve(basePath, route.path),
            title: this.$t(('route.') + route.meta) && this.$t(('route.') + route.meta.title)
          }
          if (route.children) {
            data.children = this.generateRoutes(route.children, data.path)
            
            if(route.children.length){
              route.children.forEach(child=>{
                if(child.children){
                  this.editDatas = this.editDatas.concat(child.children)
                }
              })
            }
          }
          res.push(data)
        }
        return res
      },
      onlyOneShowingChild(children = [], parent) {
        let onlyOneChild = null
        const showingChildren = children.filter(item => !item.hidden)

        if (showingChildren.length === 1) {
          onlyOneChild = showingChildren[0]
          onlyOneChild.path = path.resolve(parent.path, onlyOneChild.path)
          return onlyOneChild
        }

        if (showingChildren.length === 0) {
          onlyOneChild = {
            ...parent,
            path: '',
            noShowingChildren: true
          }
          return onlyOneChild
        }

        return false
      },
      getRoutes() {
        let data = deepClone1([...constantRouterMap1, ...asyncRouterMap1]);
        this.routes = this.generateRoutes(data)
        userInfoAPI.getUserInfo().then(res => {
          this.userInfo = res.data.data
        })
      },
    }
  }
</script>
<style lang='scss' scoped>
  /deep/.el-dialog__title {
    color: #fff;
  }

  /deep/ .el-dialog__header {
    background-color: rgb(62, 62, 238);
  }

  /deep/ .el-dialog__headerbtn {
    i {
      color: #fff;
    }
  }

  .role {
    height: 20px;
  }

  .role1 {
    margin-bottom: 20px;

    .el-form-item {
      margin-left: 20px;
    }
  }

  .role2 {
    margin-left: 20px;
    margin-bottom: 20px;
  }

  .role3 {
    margin-left: 28%;
  }
</style>
